import React, { useState, useEffect } from 'react';
import { Section } from 'uikit-react';
import { GetApi } from '../../services/auth';
import { toMilhar } from '../../services/funcoes';

const KPIDashboard = () => {
  const [KPIs, setKPIs] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => { 
    getKPIs(); 
  }, []);

  // Simulando a função GetApi - substitua pela sua implementação real
//   const GetApi = async (endpoint) => {
//     // Simular delay da API
//     await new Promise(resolve => setTimeout(resolve, 1000));
    
//     // Retornar dados mockados - substitua pela sua chamada real da API
//     return {
//       data: {
//         sucesso: true,
//         kpis: [
//           {
//             "tipoDescricao": "PROFISSIONAIS",
//             "statusDescricao": "ATIVO",
//             "qtd": 39
//           },
//           {
//             "tipoDescricao": "PROFISSIONAIS",
//             "statusDescricao": "CADASTRADO BLOQUEADO",
//             "qtd": 0
//           },
//           {
//             "tipoDescricao": "PROFISSIONAIS",
//             "statusDescricao": "PRÉ CADASTRO",
//             "qtd": 71
//           },
//           {
//             "tipoDescricao": "RESPONSÁVEL ESTABELECIMENTO",
//             "statusDescricao": "ATIVO",
//             "qtd": 2
//           },
//           {
//             "tipoDescricao": "RESPONSÁVEL ESTABELECIMENTO",
//             "statusDescricao": "CADASTRADO BLOQUEADO",
//             "qtd": 0
//           },
//           {
//             "tipoDescricao": "RESPONSÁVEL ESTABELECIMENTO",
//             "statusDescricao": "PRÉ CADASTRO",
//             "qtd": 0
//           },
//           {
//             "tipoDescricao": "ESTABELECIMENTO",
//             "statusDescricao": "BLOQUEADO",
//             "qtd": 0
//           },
//           {
//             "tipoDescricao": "ESTABELECIMENTO",
//             "statusDescricao": "LOJA ATIVA",
//             "qtd": 22813
//           }
//         ]
//       }
//     };
//   };

  const getKPIs = async () => {
    try {
    //   setLoading(true);
      const response = await GetApi("Admin/kpis");
      console.log("response: ", response.data);
      if(response?.data.sucesso){
        setKPIs(response.data.kpis);
      }
    } catch (error) {
      console.error("Erro ao buscar KPIs:", error);
    } finally {
    //   setLoading(false);
    }
  };

  // Organizar dados por tipo
  const organizarKPIsPorTipo = () => {
    const grupos = {};
    
    KPIs.forEach(kpi => {
      if (!grupos[kpi.tipoDescricao]) {
        grupos[kpi.tipoDescricao] = [];
      }
      grupos[kpi.tipoDescricao].push(kpi);
    });
    
    return grupos;
  };

  // Calcular totais por tipo
  const calcularTotais = (kpis) => {
    return kpis.reduce((total, kpi) => total + kpi.qtd, 0);
  };

  // Configuração de cores e ícones por tipo
  const getConfiguracao = (tipo) => {
    const configs = {
      'PROFISSIONAIS': {
        icon: '👥',
        cardClass: 'uk-card-secondary',
        badgeClass: 'uk-badge uk-background-primary',
        titleClass: 'uk-text-primary'
      },
      'RESPONSÁVEL ESTABELECIMENTO': {
        icon: '🛡️',
        cardClass: 'uk-card-secondary',
        badgeClass: 'uk-badge uk-background-primary',
        titleClass: 'uk-text-primary'
      },
      'ESTABELECIMENTO': {
        icon: '🏢',
        cardClass: 'uk-card-secondary',
        badgeClass: 'uk-badge uk-background-primary',
        titleClass: 'uk-text-primary'
      }
    };
    return configs[tipo] || configs['PROFISSIONAIS'];
  };

  // Configuração de badges por status
  const getBadgeStatus = (status) => {
    const badges = {
      'ATIVO': 'uk-badge uk-badge-success',
      'LOJA ATIVA': 'uk-badge uk-badge-success',
      'PRÉ CADASTRO': 'uk-badge uk-badge-warning',
      'CADASTRADO BLOQUEADO': 'uk-badge uk-badge-danger',
      'BLOQUEADO': 'uk-badge uk-badge-danger'
    };
    return badges[status] || 'uk-badge';
  };

  // Loading state
//   if (loading) {
//     return (
//       <div className="uk-section uk-section-muted uk-section-large">
//         <div className="uk-container uk-container-expand">
//           <div className="uk-text-center">
//             <div data-uk-spinner="ratio: 2"></div>
//             <p className="uk-text-lead uk-margin-top">Carregando KPIs...</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Se não há dados
//   if (!KPIs || KPIs.length === 0) {
//     return (
//       <div className="uk-section uk-section-muted uk-section-large">
//         <div className="uk-container uk-container-expand">
//           <div className="uk-text-center">
//             <span data-uk-icon="icon: warning; ratio: 3" className="uk-text-warning"></span>
//             <h2 className="uk-text-warning">Nenhum dado encontrado</h2>
//             <p className="uk-text-muted">Não foi possível carregar os KPIs.</p>
//             <button 
//               className="uk-button uk-button-primary"
//               onClick={getKPIs}
//             >
//               Tentar Novamente
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

  const kpisPorTipo = organizarKPIsPorTipo();

  return (
    KPIs.length > 0 &&
    <Section className="uk-container uk-container-xlarge uk-margin">   
        <h4 className="uk-text-bold" style={{ marginTop: '20px'}}> Indicadores </h4> 
<div className="uk-container uk-container-expand"></div>
      <div className="uk-container uk-container-expand">
        {/* Header */}
        {/* <div className="uk-margin-large-bottom uk-text-center">
          <h1 className="uk-heading-line uk-text-center">
            <span>Dashboard de KPIs</span>
          </h1>
          <p className="uk-text-lead uk-text-muted">Indicadores organizados por tipo de usuário</p>
          <button 
            className="uk-button uk-button-default uk-button-small"
            onClick={getKPIs}
            disabled={loading}
          >
            <span data-uk-icon="icon: refresh"></span>
            Atualizar Dados
          </button>
        </div> */}

        {/* Cards Container */}
        <div className="uk-grid-match uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m" data-uk-grid>
          {Object.entries(kpisPorTipo).map(([tipo, kpis]) => {
            const config = getConfiguracao(tipo);
            const total = calcularTotais(kpis);

            return (
              <div key={tipo}>
                <div className={`uk-card ${config.cardClass} uk-card-hover uk-card-body`}>
                  {/* Header do Card */}
                  <div className="uk-flex uk-flex-between uk-flex-middle uk-margin-medium-bottom">
                    <div className="uk-flex uk-flex-middle">

                  {/* Título */}
                  <h3 className={`uk-card-title ${config.titleClass} uk-margin-medium-bottom`}>
                    {tipo.replace('_', ' ')}
                  </h3>
                    </div>
                    <div className="uk-text-right">
                      <div className="uk-text-large uk-text-bold">{toMilhar(total)}</div>
                      <div className="uk-text-small uk-text-muted">Total</div>
                    </div>
                  </div>


                  {/* Status com Legendas */}
                  <div className="uk-flex uk-flex-wrap uk-grid-small uk-margin-remove-top" data-uk-grid>
                    {kpis.map((kpi, index) => (
                      <div key={index} className="uk-width-auto">
                        <div className="uk-flex uk-flex-middle uk-margin-small-bottom">
                          <span className={`${getBadgeStatus(kpi.statusDescricao)} uk-margin-small-right`}>
                            {toMilhar(kpi.qtd)}
                          </span>
                          <span className="uk-text-small uk-text-nowrap uk-text-emphasis">
                            {kpi.statusDescricao}
                          </span>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Progresso Visual */}
                  <div className="uk-margin-medium-top">
                    {/* <div className="uk-margin-small-bottom">
                      <div className="uk-text-small uk-text-muted">Distribuição</div>
                    </div> */}
                    {kpis.map((kpi, index) => {
                      const percentual = total > 0 ? (kpi.qtd / total) * 100 : 0;
                      const progressClass = kpi.statusDescricao.includes('ATIVO') ? 'uk-progress-success' :
                                           kpi.statusDescricao.includes('PRÉ') ? 'uk-progress-warning' :
                                           kpi.statusDescricao.includes('BLOQUEADO') ? 'uk-progress-danger' : '';
                      
                      return  (
                        <div key={index} className="uk-margin-small-bottom">
                          <div className="uk-flex uk-flex-between uk-text-small">
                            <span>{kpi.statusDescricao}</span>
                            <span>{percentual.toFixed(1)}%</span>
                          </div>
                          <progress 
                            className={`uk-progress ${progressClass}`} 
                            value={percentual} 
                            max="100"
                          />
                        </div>
                      ) ;
                    })}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Resumo Geral */}
        {/* <div className="uk-margin-large-top">
          <div className="uk-card uk-card-default uk-card-body">
            <h3 className="uk-card-title uk-text-center">
              <span data-uk-icon="icon: thumbnails; ratio: 1.2" className="uk-margin-small-right"></span>
              Resumo Geral
            </h3>
            <div className="uk-overflow-auto">
              <table className="uk-table uk-table-hover uk-table-middle uk-table-divider">
                <thead>
                  <tr>
                    <th className="uk-table-shrink">Tipo</th>
                    <th>Status</th>
                    <th className="uk-text-center">Quantidade</th>
                    <th className="uk-text-center">% do Tipo</th>
                  </tr>
                </thead>
                <tbody>
                  {KPIs.map((kpi, index) => {
                    const totalTipo = calcularTotais(kpisPorTipo[kpi.tipoDescricao]);
                    const percentual = totalTipo > 0 ? ((kpi.qtd / totalTipo) * 100).toFixed(1) : '0.0';
                    const config = getConfiguracao(kpi.tipoDescricao);
                    
                    return (
                      <tr key={index}>
                        <td>
                          <div className="uk-flex uk-flex-middle">
                            <span className="uk-margin-small-right" style={{ fontSize: '1.5rem' }}>
                              {config.icon}
                            </span>
                            <span className="uk-text-small uk-text-bold">
                              {kpi.tipoDescricao}
                            </span>
                          </div>
                        </td>
                        <td>
                          <span className={getBadgeStatus(kpi.statusDescricao)}>
                            {kpi.statusDescricao}
                          </span>
                        </td>
                        <td className="uk-text-center uk-text-bold">
                          {kpi.qtd.toLocaleString()}
                        </td>
                        <td className="uk-text-center">
                          <span className="uk-badge uk-badge-notification uk-background-muted">
                            {percentual}%
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div> */}
      </div>
    </Section>
  );
};

export default KPIDashboard;